<div [formGroup]="group">
    <text-field

            [placeholder]="Yii.t('wui-shared-js', 'Votre identifiant')"
            [label]="Yii.t('wui-shared-js', 'Votre identifiant')"
            [group]="group" controlName="uid" [id]="'e2e-lgn'"></text-field>

    <text-field
            class="pwd sep-top"
            [placeholder]="Yii.t('wui-shared-js', 'Votre mot de passe')" type="password"
            [label]="Yii.t('wui-shared-js', 'Votre mot de passe')"
            [group]="group" controlName="pwd" [id]="'e2e-pwd'"></text-field>
</div>
